import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IEnvironment } from '../environment/environment.interface';
import { GeoServiceInterface } from './geo-service.interface';
import { Observable } from 'rxjs';
import { GeoResponse } from './data.response';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GeoService implements GeoServiceInterface {
  private endpointApi: string;
  private tsApi: string;

  constructor(@Inject('IEnvironmentService') private envService: IEnvironment, private http: HttpClient) {
    this.endpointApi = this.envService.getVar('services.api') as string;
    this.tsApi = this.transformToTsApi();
  }

  public getGeo(): Observable<GeoResponse> {
    return this.http.get(`${this.tsApi}/v3/geo`).pipe(
      map((response: any) => {
        return new GeoResponse(response);
      })
    );
  }

  transformToTsApi(): string {
    return this.endpointApi.split('/v1/')[0];
  }
}
